import React from 'react'


function Footer(){
    return(
        <footer>
            Made with love by Jorge Goris &copy; 2020
        </footer>
    )
}


export default Footer